var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mobile-month-audit-container"},[_c('div',{staticClass:"mobile-header-filter-wrap"},[_vm._t("header-filter")],2),_c('div',{staticClass:"mobile-table-wrap"},[_c('div',{staticClass:"custom-table-content-wrap"},[_vm._t("body-table")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }